import {
  buildDeleteCatalogMockResponse,
  buildGetCatalogImportDetailsMockResponse,
  buildGetCatalogsMockResponse,
  buildImportCsvMockResponse,
  buildModifyCatalogMockResponse,
} from "../../../mocks/catalogMock";

export const mockCatalogProvider = {
  modifica: async (data) => {
    return Promise.resolve({
      status: 202,
      data: buildModifyCatalogMockResponse(),
    });
  },

  elimina: async (data) => {
    return Promise.resolve({
      status: 202,
      data: buildDeleteCatalogMockResponse(),
    });
  },

  getCatalogs: async (data, headers) => {
    return Promise.resolve({
      status: 200,
      data: buildGetCatalogsMockResponse({
        limit: data?.limit,
        offset: data?.offset,
      }),
    });
  },

  getCatalogImportDetails: async (data, headers) => {
    return Promise.resolve({
      status: 200,
      data: buildGetCatalogImportDetailsMockResponse({
        limit: data?.limit,
        page: data?.page,
      }),
    });
  },

  importCsv: async (formData) => {
    return Promise.resolve({
      status: 202,
      data: buildImportCsvMockResponse(),
    });
  },
};

